import { CardIssueCustomizationOptionModel, CardIssueCustomizationOptionType } from "@/admin/types";
import _ from "lodash";

const getOptionText = (option: CardIssueCustomizationOptionModel) => {
  const optionText = `${option.name} - ${option.value}`;
  return option.isDeleted ? `${optionText} (No Longer Available)` : optionText;
};

export const getSelectOptions = (options: CardIssueCustomizationOptionModel[], optionType: CardIssueCustomizationOptionType) => {
  const filtered = _.filter(options, option => option.optionType === optionType);
  const sorted = _.sortBy(filtered, option => option.isDeleted, option => !option.isDefaultOption, option => option.value);
  return _.map(sorted, option => ({
    value: option.value,
    text: getOptionText(option),
    disabled: option.isDeleted
  }));
};
